<template>
    <div class="front cabinet nosidebar"> 
        <div id="header">
            <div class="container">
                <div id="logo" class="block">
                    <div class="content">
                        <a href="#"><img src="../assets/images/logo.png"></a>
                    </div>
                </div> 
                
                <div id="slogan" class="block">
                    <div class="content">
                        <a href="#">Детская стоматология <span>и Ортодонтия</span></a>
                    </div>
                </div> 
                
                <div id="cabinet" class="block notauthorized">
                    <div class="content">
                        <router-link to="/login">Вход</router-link>/<router-link to="/register">Регистрация</router-link>
                    </div>
                </div> 
                <div id="online" class="block">
                    <div class="content">
                        <router-link to="/appointment"><a href="#" class="button">Запись на прием</a></router-link>
                        
                    </div>
                </div> 
                <div id="phone" class="block">
                    <div class="content">
                        <a class="mangophone" href="tel:+78122009571">+7 812 200-95-71</a>
                    </div>
                </div>
            </div>
        </div>

        <router-view />
    </div>

</template>